import { render, staticRenderFns } from "./RightDiseaseRevenue.vue?vue&type=template&id=40838af3&scoped=true"
import script from "./RightDiseaseRevenue.vue?vue&type=script&lang=js"
export * from "./RightDiseaseRevenue.vue?vue&type=script&lang=js"
import style0 from "./RightDiseaseRevenue.vue?vue&type=style&index=0&id=40838af3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40838af3",
  null
  
)

export default component.exports